/**
 * Notifications Module
 * Exports all notification-related components, hooks, and utilities
 */

// Types
export * from "./types";

// Components
export { CelebrationModal } from "./components/CelebrationModal";
export { NotificationsCarousel } from "./components/NotificationsCarousel";

// Hooks
export { useNotificationRealtime } from "./hooks/useNotificationRealtime";

// Utilities
export { 
  getLottieAnimation, 
  getLottieAnimationsList, 
  getLottieAnimationsByCategory,
  LOTTIE_ANIMATIONS,
  DEFAULT_LOTTIE_BY_TYPE,
} from "./utils/lottieAnimations";

export { 
  getThemeById, 
  NOTIFICATION_THEMES,
  DEFAULT_THEME_BY_TYPE,
} from "./utils/themes";

export { createScoreNotifications } from "./utils/createScoreNotifications";

